"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _listItem = _interopRequireDefault(require("./list-item"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const List = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "List",
  class: "pl-li58fgg"
});

/**
 * MarqueeRTB Component.
 *
 * @param {Object} props React props
 * @param {String} props.iconColor Color of the icon
 * @param {Array} props.rtbList RTB List of items
 * @returns {React.ReactElement} MarqueeRTB Component
 * @public
 */

function MarqueeRTB({
  iconColor,
  rtbList
}) {
  const [isActive, setIsActive] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-cy": "marquee-rtb",
    className: "rtb-list-container"
  }, /*#__PURE__*/_react.default.createElement(List, {
    iconColor: iconColor
  }, rtbList?.map((rtb, i) => {
    return /*#__PURE__*/_react.default.createElement(_listItem.default, (0, _extends2.default)({
      i: i,
      key: i,
      expanded: isActive === i,
      setExpanded: setIsActive
    }, rtb));
  })));
}
var _default = exports.default = MarqueeRTB;
MarqueeRTB.propTypes = {
  iconColor: _propTypes.default.string,
  rtbList: _propTypes.default.array
};